import config from "../config/config";
import { TFunction } from "i18next";
import { BffUserData } from "../services/api/user-api";
import { MyPagesRoutes } from "../types/routes";
import { System } from "../models/system";

export const notImplemented = (): never => {
	throw new Error("Not Implemented");
};

export const getMarcException = (code: string, t: TFunction<"translation", undefined>) => {
	return {
		title: t(`marcExceptions.${code}.title`),
		description: t(`marcExceptions.${code}.description`),
	};
};

export const getImageUrl = (imageGuid: Guid) => {
	return imageGuid ? `${config.imageCdnUrl}/${imageGuid}` : undefined;
};

export const getInitialsFromName = (name: string) => {
	const split = name.split(" ");

	if (split.length > 1) {
		return `${split[0][0]}${split[1][0]}`.toLocaleUpperCase();
	} else if (split.length === 1) {
		return `${split[0][0]}`.toLocaleUpperCase();
	} else {
		return "";
	}
};

export const getClaimValue = (claims: BffUserData | undefined, type: string): string | undefined => {
	const claim = claims?.find((c) => c.type === type);
	return typeof claim?.value === "string" ? claim.value : undefined;
};

export const hasClaimsRole = (claims: BffUserData | undefined, role: string) => {
	const claim = claims?.find((c) => c.type === "role" && c.value === role);
	return Boolean(claim);
};

export function getColleaguesLink(systems: System[], date: Date) {
	const baseLink = `/${MyPagesRoutes.Colleagues}`;
	if (systems.length === 1) {
		return `${baseLink}/${systems[0].name}?date=${date.toISOString()}`;
	}
	return `${baseLink}?date=${date.toISOString()}`;
}

export const mod97CheckSum = (digits: string) => {
	let remainder = 0;
	for (const digit of digits) {
		remainder = (remainder * 10 + parseInt(digit, 10)) % 97;
	}
	return remainder === 1;
};
